<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>Notificaciones</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar nombre..."
        single-line
        hide-details
      ></v-text-field>
    </v-toolbar>
    <v-data-table
      rows-per-page-text="Filas por página:"
      :rows-per-page-items="rowsPerPageItems"
      :headers="headers"
      :items="notificaciones"
      :search="search"
      :loading="loading"
      :pagination.sync="pagination"
      item-key="key"
      :expand="expand"
      class="elevation-1"
    >
      <template v-slot:no-data>
        <v-alert v-if="!loading" :value="true" type="warning" color="orange">
          No hay datos guardados
        </v-alert>
        <v-alert v-if="loading" :value="true" type="info" color="blue">
          Cargando...
        </v-alert>
      </template>
      <template v-slot:progress>
        <v-progress-linear color="blue" indeterminate></v-progress-linear>
      </template>
      <template v-slot:items="props">
        <tr
          :class="{ unread: !isReaded(props.item) }"
          @click="props.expanded = !props.expanded"
        >
          <td>{{ props.item.name }}</td>
          <td class="text-xs-right">
            <div class="v-icon" style="font-size:inherit">
              <ProfileLink
                :key="props.item.trigger.id"
                v-bind:idKey="props.item.trigger.id"
                v-bind:type="props.item.trigger.type"
              />
              &nbsp;
              <TooltipUser v-if="props.item.trigger.type === 'user'" />
              <TooltipSensor v-if="props.item.trigger.type === 'sensor'" />
            </div>
          </td>
          <td class="text-xs-right">{{ mostrarTipo(props.item.type) }}</td>
          <td class="text-xs-right">{{ mostrarFecha(props.item.date) }}</td>
          <td class="justify-center layout px-0">
            <!-- Botón de marcar como no leído -->
            <v-tooltip v-if="isReaded(props.item)" bottom color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn
                  flat
                  icon
                  color="secondary"
                  v-on="on"
                  @click.stop="changeReadState(props.item)"
                >
                  <v-icon>
                    check_circle
                  </v-icon>
                </v-btn>
              </template>
              <span>Marcar como no leído</span>
            </v-tooltip>
            <!-- Botón de leído -->
            <v-tooltip v-if="!isReaded(props.item)" bottom color="blue darken-4">
              <template v-slot:activator="{ on }">
                <v-btn
                  flat
                  icon
                  color="blue darken-4"
                  v-on="on"
                  @click.stop="changeReadState(props.item)"
                >
                  <v-icon>
                    done_all
                  </v-icon>
                </v-btn>
              </template>
              <span>Marcar como leído</span>
            </v-tooltip>
            <!-- Botón de aceptar -->
            <v-tooltip v-if="isRequest(props.item)&&!isAccepted(props.item)" bottom color="green">
              <template v-slot:activator="{ on }">
                <v-btn
                  flat
                  icon
                  color="green"
                  v-on="on"
                  @click.stop="markItemAccepted(props.item)"
                >
                  <v-icon>
                    assignment_turned_in
                  </v-icon>
                </v-btn>
              </template>
              <span>Aceptar</span>
            </v-tooltip>
            <!-- Botón de aceptado -->
            <v-tooltip v-if="isAccepted(props.item)" bottom color="green darken-3">
              <template v-slot:activator="{ on }">
                <v-btn
                    flat
                    icon
                    color="green darken-3"
                    v-on="on"
                    @click.stop=""
                >
                  <v-icon>
                    check_circle
                  </v-icon>
                </v-btn>
              </template>
              <span>Aceptado</span>
            </v-tooltip>
            <!-- Botón de borrar -->
            <v-tooltip bottom color="red">
              <template v-slot:activator="{ on }">
                <v-btn
                  flat
                  icon
                  color="red"
                  v-on="on"
                  @click.stop="deleteItem(props.item)"
                >
                  <v-icon>
                    delete
                  </v-icon>
                </v-btn>
              </template>
              <span>Borrar</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
      <template v-slot:no-results>
        <v-alert :value="true" type="error" color="red">
          No se ha encontrado la notificación "{{ search }}".
        </v-alert>
      </template>
      <template v-slot:expand="props">
        <v-card>
          <v-card-text v-if="props.item.description === ''">
            Sin descripción.
          </v-card-text>
          <v-card-text v-if="props.item.description !== ''">
            {{ props.item.description }}
          </v-card-text>
        </v-card>
      </template>
      <template v-slot:pageText="props">
        Filas de {{ props.pageStart }} a {{ props.pageStop }} de
        {{ props.itemsLength }} totales
      </template>
    </v-data-table>
  </div>
</template>

<script>
// @ is an alias to /src
import TooltipUser from "./TooltipUser.vue";
import TooltipSensor from "./TooltipSensor.vue";
import ProfileLink from "@/components/links/ProfileLink.vue";
import firebase from "firebase";

let firebaseApp;
firebaseApp = firebase.app();
export const db = firebaseApp.database();

// Muestra las notificaciones del usuario
// @group Listas
export default {
  components: {
    TooltipUser,
    TooltipSensor,
    ProfileLink
  },
  data() {
    return {
      selected: [],
      search: "",
      loading: true,
      expand: false,
      pagination: {
        descending: true,
        sortBy: "date"
      },
      rowsPerPageItems: [10 /*, 20, 30, 40*/],
      headers: [
        { text: "Nombre", align: "left", value: "name" },
        { text: "Activador", align: "right", value: "trigger.type" },
        { text: "Tipo", align: "right", value: "type" },
        { text: "Fecha", align: "right", value: "date" },
        { text: "Acciones", align: "center", sortable: false }
      ]
    };
  },
  computed: {
    // @vuese
    // Devuelve el ID del usuario
    getUID() {
      return this.$store.state.user.uid;
    }
  },
  created() {
    this.$bindAsArray(
      "notificaciones",
      db
        .ref("notifications")
        .orderByChild("dest")
        .equalTo(this.getUID),
      snap => {
        this.loading = false;
      },
      error => {
        this.loading = false;
      }
    );
    setTimeout(
      function() {
        this.loading = false;
      }.bind(this), 3000);
  },
  methods: {
    // @vuese
    // Procesa un objeto date y lo muestra formateado
    // @arg Fecha
    mostrarFecha(fecha) {
      let dateStr = JSON.parse('"' + fecha + '"');
      let date = new Date(dateStr);
      return date.toLocaleString("es-ES");
    },
    // @vuese
    // Devuelve el nombre formateado del tipo de notificación
    // @arg Tipo
    mostrarTipo(tipo) {
      if (tipo === "alert") {
        return "Alerta";
      }
      if (tipo === "request") {
        return "Petición";
      }
      if (tipo === "sensor_created") {
        return "Sensor creado";
      }
      return tipo;
    },
    // @vuese
    // Indica si una notificación está leída
    // @arg Item de la lista
    isReaded(item) {
      return item.readed;
    },
    isRequest(item) {
      return item.type === "request";
    },
    isAccepted(item) {
      if (item.accepted !== null) {
        return item.accepted;
      }
      return false;
    },
    // @vuese
    // Cambia el estado de leído de una notificación
    // @arg Item de la lista
    changeReadState(item) {
      item.readed = item.readed ? false : true;
      this.$store.dispatch("changeReadNotification", {
        readed: item.readed,
        key: item.key
      });
    },
    markItemAccepted(item) {
      item.accepted = true;
      this.$store.dispatch("markItemAccepted", {
        key: item.key
      });
    },
    // @vuese
    // Borrar una notificación
    // @arg Item de la lista
    deleteItem(item) {
      if (
        confirm(
          "¿Estás seguro de que quieres borrar la notificación " +
            item.name +
            "?"
        )
      ) {
        this.$store.dispatch("deleteObject", {
          route: "notifications",
          key: item.key
        });
        alert("Notificación " + item.name + " borrada.");
      }
    }
  }
};
</script>

<style>
.unread {
  background-color: lightblue;
}
</style>
